/** How often the game loop refreshes everything regardless of what's queued. */
export const HEARTBEAT_MS = 60_000;
